export default "__VITE_PUBLIC_ASSET__e7ea2b54__"